import env from '@/env'
import { loggerConnectOptions } from '@/enum/socketConnectionConfig'
import StorageLogger from '@voicenter-team/socketio-storage-logger'

class Logger extends StorageLogger {
    constructor () {
        super({
            url: env.VITE_APP_LOGGER_API_URL,
            socketOptions: {
                ...loggerConnectOptions
            },
            loggerOptions: {
                system: 'realtime-dashboard',
                logToConsole: true,
                overloadGlobalConsole: false,
                socketEmitInterval: 10000
            }
        })
    }
}

export default new Logger()
